<template>
    <button class="circle-number" :class="variant">
        <span
            :class="[
                numberInput && numberInput.length > 2
                    ? 'circle-number-3'
                    : 'circle-number-2',
            ]"
            >{{ numberInput }}</span
        >
    </button>
</template>

<script>
export default {
    props: {
        numberInput: {
            required: true,
        },
        variant: {
            type: String,
            required: false,
            default: 'primary',
        },
    },
};
</script>

<style lang="scss">
@import 'CircleNumber';
</style>
